export const parseJSON = (response, debug = false) => {
    if (debug) {
        console.log(response)
    }

    return response
}
